exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tags[data-v-5f071212]:hover{\n    color: white!important;\n}\n", ""]);

// exports
